import { template as template_a4f4afa1395044b9bf90ebec578501c3 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { fn } from '@ember/helper';
import { isPresent } from '@ember/utils';
import { not, and, or } from 'ember-truth-helpers';
import { t } from 'ember-intl';
import TaskConfigBarcode from 'eflex/components/task-context-config/barcode';
import TaskConfigButton from 'eflex/components/task-context-config/button';
import TaskConfigCobot from 'eflex/components/task-context-config/cobot';
import TaskConfigDecision from 'eflex/components/task-context-config/decision';
import TaskConfigErrorProofing from 'eflex/components/task-context-config/errorproofing';
import TaskConfigLightGuide from 'eflex/components/task-context-config/lightguide';
import TaskConfigMultispindle from 'eflex/components/task-context-config/multispindle';
import TaskConfigNodeRed from 'eflex/components/task-context-config/nodered';
import TaskConfigPick from 'eflex/components/task-context-config/pick';
import TaskConfigPlc from 'eflex/components/task-context-config/plc';
import TaskConfigPushToSchedule from 'eflex/components/task-context-config/pushtoschedule';
import TaskConfigSerialNumberTransfer from 'eflex/components/task-context-config/serialnumbertransfer';
import TaskConfigOpcUa from 'eflex/components/task-context-config/opc-ua';
import TaskConfigTimer from 'eflex/components/task-context-config/timer';
import TaskConfigTorque from 'eflex/components/task-context-config/torque';
import TaskConfigVision from 'eflex/components/task-context-config/vision';
import TaskConfigViewFile from 'eflex/components/task-context-config/view-file';
import BsForm from 'eflex/components/bs-form';
import BsButton from 'eflex/components/bs-button';
import { copyToSelectedContexts } from 'eflex/services/task-config-repo';
const getTaskContextComponent = (taskType)=>{
    switch(taskType){
        case 'barcode':
            {
                return TaskConfigBarcode;
            }
        case 'button':
            {
                return TaskConfigButton;
            }
        case 'cobot':
            {
                return TaskConfigCobot;
            }
        case 'decision':
            {
                return TaskConfigDecision;
            }
        case 'errorProofing':
            {
                return TaskConfigErrorProofing;
            }
        case 'lightGuide':
            {
                return TaskConfigLightGuide;
            }
        case 'multispindle':
            {
                return TaskConfigMultispindle;
            }
        case 'nodeRed':
            {
                return TaskConfigNodeRed;
            }
        case 'opcUa':
            {
                return TaskConfigOpcUa;
            }
        case 'pick':
            {
                return TaskConfigPick;
            }
        case 'plc':
            {
                return TaskConfigPlc;
            }
        case 'pushToSchedule':
            {
                return TaskConfigPushToSchedule;
            }
        case 'serialNumberTransfer':
            {
                return TaskConfigSerialNumberTransfer;
            }
        case 'timer':
            {
                return TaskConfigTimer;
            }
        case 'torque':
            {
                return TaskConfigTorque;
            }
        case 'vision':
            {
                return TaskConfigVision;
            }
        case 'viewFile':
            {
                return TaskConfigViewFile;
            }
        default:
            {
                return null;
            }
    }
};
const hasComplexOption = (componentOptions)=>{
    return componentOptions?.some((item)=>item.isSimple === false) ?? false;
};
export default class TaskContextConfig extends Component {
    @service
    intl;
    get enabledLabel() {
        let label = this.intl.t('enabled');
        if (isPresent(this.args.taskConfig.configName)) {
            label += ` - ${this.args.taskConfig.configName}`;
        }
        return label;
    }
    static{
        template_a4f4afa1395044b9bf90ebec578501c3(`
    <BsForm
      @showValidations={{@showValidations}}
      @disabled={{or @disabled @taskConfig.isIgnored}}
      @model={{@taskConfig}}
      ...attributes
    as |form|>
      <div class="row form-row">
        <form.element
          @controlType="checkbox"
          @property="enabled"
          @label={{this.enabledLabel}}
          class="enable-checkbox model-specific w-50 form-switch ps-4"
        as |el|>
          <el.control @disabled={{@disabled}} />
        </form.element>
        {{#if
          (and
            @task.usesComponents
            (not @task.component.isAlwaysRun)
            (hasComplexOption @task.component.options)
          )
        }}
          <form.element
            @controlType="checkbox"
            @model={{@taskConfig}}
            @property="ignored"
            @label={{ t "plant.task.ignoreComplexOption" }}
            class="ignore-option model-specific"
          as |el|>
            <el.control @disabled={{ or @disabled @taskConfig.configOption.isSimple }} />
          </form.element>
        {{/if}}
      </div>

      <div class="model-specific row form-row mb-3">
        <div class="col-4">
          <form.element
            @label={{t "release.targetLabel"}}
            @property="targetCycleTime"
            @controlType="number"
            @size="sm"
          as |el|>
            <el.control disabled={{@disabled}} class="target-cycle-time" />
          </form.element>
        </div>
      </div>

      {{#let (getTaskContextComponent @task.taskType) as |TaskContextComponent|}}
        <TaskContextComponent
          @taskConfig={{@taskConfig}}
          @task={{@task}}
          @disabled={{@disabled}}
          @form={{form}}
        />
      {{/let}}
    </BsForm>

    {{#unless @task.usesOperations}}
      <div class="d-flex justify-content-end mt-2">
        <BsButton
          @type="secondary"
          @onClick={{fn copyToSelectedContexts @taskConfig @selectedContext}}
          @disabled={{@task.component.isAlwaysRun}}
          @size="sm"
          class="test-copy-to-contexts"
        >
          {{#if @task.usesComponents}}
            {{t "copyOptionSpecificSelected"}}
          {{else}}
            {{t "copyModelSpecificSelected"}}
          {{/if}}
        </BsButton>
      </div>
    {{/unless}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
